export const notificationsFilters = Object.freeze({
  ALL: 'all',
  OWN: 'own'
});
